export enum AppLayoutBreakpoint {
  /**
   * Extra small AppLayout breakpoint.
   */
  Width375 = 375,

  /**
   * Small AppLayout breakpoint.
   */
  Width568 = 568,

  /**
   * Medium AppLayout breakpoint.
   */
  Width812 = 812,

  /**
   * Large AppLayout breakpoint.
   */
  Width1032 = 1032,

  /**
   * Extra Large AppLayout breakpoint.
   */
  Width1132 = 1132,

  /**
   * Back Button medium floating breakpoint.
   */
  Width1185 = 1185,

  /**
   * Back Button large floating breakpoint.
   */
  Width1350 = 1350,

  /**
   * Back Button extra large floating breakpoint.
   */
  Width1600 = 1600,
}

export enum LegacyPageLayoutBreakpoint {
  /**
   * Small legacy PageLayout, Narrow PaneLayout breakpoint.
   */
  Width700 = 700,

  /**
   * Medium legacy PageLayout breakpoint.
   */
  Width1044 = 1044,

  /**
   * Large legacy PageLayout breakpoint.
   */
  Width1304 = 1304,
}

export enum ContentColumnBreakpoint {
  /**
   * Narrow ContentColumn breakpoint.
   */
  Width370 = 370,

  /**
   * Medium ContentColumn, Narrow ModalScreen breakpoint.
   */
  Width500 = 500,

  /**
   * Wide ContentColumn breakpoint.
   */
  Width596 = 596,
}

export enum FeatureBreakpoint {
  /**
   *  Narrow Metadata breakpoint.
   */
  Width680 = 680,

  /**
   * Narrow ScreenWidth breakpoint.
   */
  Width855 = 855,
}

export type Breakpoint = AppLayoutBreakpoint | LegacyPageLayoutBreakpoint | ContentColumnBreakpoint | FeatureBreakpoint;
